var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960.953,
    height: 549.906,
    viewBox: "0 0 960.953 549.906",
    xmlnxlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(-514.893 -261.052)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 555.41,
    height: 360.848,
    transform: "translate(919.356 262.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747-2822",
    "data-name": "Path 1747",
    d: "M1086.152,560.533H528.583V197.526h557.569Zm-555.41-2.159h553.251V199.685H530.741Z",
    transform: "translate(389.694 63.526)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748-2823",
    "data-name": "Path 1748",
    d: "M755.41,231.221c16.314.279,16.311,24.545,0,24.821C739.1,255.764,739.1,231.5,755.41,231.221Z",
    transform: "translate(406.746 66.203)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749-2824",
    "data-name": "Path 1749",
    d: "M787.746,231.221c16.314.279,16.311,24.545,0,24.821C771.432,255.764,771.435,231.5,787.746,231.221Z",
    transform: "translate(409.315 66.203)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750-2825",
    "data-name": "Path 1750",
    d: "M820.081,231.221c16.314.279,16.311,24.545,0,24.821C803.767,255.764,803.77,231.5,820.081,231.221Z",
    transform: "translate(411.885 66.203)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 111.082,
    height: 1.346,
    transform: "translate(1015.291 392.451)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751-2826",
    "data-name": "Path 1751",
    d: "M967.108,510.622H814.286V367.9H967.108Zm-151.476-1.346H965.762V369.245H815.633Z",
    transform: "translate(412.397 77.064)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 1.347,
    height: 207.201,
    transform: "matrix(0.682, -0.731, 0.731, 0.682, 1226.896, 446.133)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 207.201,
    height: 1.347,
    transform: "matrix(0.731, -0.682, 0.682, 0.731, 1226.894, 586.521)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752-2827",
    "data-name": "Path 1752",
    d: "M982.719,303.624H617.831V278.714H982.719Zm-363.541-1.346H981.373V280.061H619.178Z",
    transform: "translate(396.786 69.977)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753-2828",
    "data-name": "Path 1753",
    d: "M752.714,405.624H618.831V380.714H752.714Zm-132.536-1.346h131.19V382.061H620.178Z",
    transform: "translate(396.865 78.083)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754-2829",
    "data-name": "Path 1754",
    d: "M752.714,444.624H618.831V419.714H752.714Zm-132.536-1.346h131.19V421.061H620.178Z",
    transform: "translate(396.865 81.182)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755-2830",
    "data-name": "Path 1755",
    d: "M752.714,483.624H618.831V458.714H752.714Zm-132.536-1.346h131.19V460.061H620.178Z",
    transform: "translate(396.865 84.28)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756-2831",
    "data-name": "Path 1756",
    d: "M653.956,350.489H618.047c2.772-11.155,2.437-23.223,0-35.908h35.908a44.638,44.638,0,0,0,0,35.908Z",
    transform: "translate(396.803 72.827)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 21.763,
    height: 4.353,
    transform: "translate(1020.291 395.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 21.763,
    height: 4.353,
    transform: "translate(1020.291 403.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 21.763,
    height: 4.353,
    transform: "translate(1020.291 412.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757-2832",
    "data-name": "Path 1757",
    d: "M904.463,400.727H868.554c2.772-11.155,2.438-23.223,0-35.908h35.908a44.638,44.638,0,0,0,0,35.908Z",
    transform: "translate(416.709 76.819)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 21.763,
    height: 4.353,
    transform: "translate(1290.704 449.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 21.763,
    height: 4.353,
    transform: "translate(1290.704 457.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 21.763,
    height: 4.353,
    transform: "translate(1290.704 466.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758-2833",
    "data-name": "Path 1758",
    d: "M947.232,329.444H911.324c2.772-11.155,2.438-23.223,0-35.908h35.908a44.638,44.638,0,0,0,0,35.908Z",
    transform: "translate(420.107 71.155)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 21.763,
    height: 4.353,
    transform: "translate(1336.872 372.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 21.763,
    height: 4.353,
    transform: "translate(1336.872 381.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 21.763,
    height: 4.353,
    transform: "translate(1336.872 389.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759-2834",
    "data-name": "Path 1759",
    d: "M366.02,355.662H304.491V322.739a30.765,30.765,0,1,1,61.529,0Z",
    transform: "translate(371.887 73.031)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760-2835",
    "data-name": "Path 1760",
    d: "M232.043,496.55h14.13L252.9,445.5H232.041Z",
    transform: "translate(532.3 296.452)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762-2836",
    "data-name": "Path 1762",
    d: "M85.489,479.131l16.549,6.422L145.95,444.73l-24.425-9.478Z",
    transform: "translate(452.824 315.188) rotate(-7)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223-2837",
    "data-name": "Path 223",
    d: "M335.679,539.218s-9.367,15.04-6.022,19.112-25.1,4.174-25.1,4.174,4.273-21.879,3.015-26.914Z",
    transform: "translate(314.181 -73.559) rotate(-8)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764-2838",
    "data-name": "Path 1764",
    d: "M324.862,479.754l-1.021,4.978s-3.064,2.987-1.532,4.48,1.021,8.463,1.021,8.463c-.857,12.709-17.89,84.124-20.936,98.073,0,0-23.489,14.935-41.872,44.307s-18.893,36.839-18.893,36.839l20.425,8.463,51.063-60.237s14.3-8.463,19.4-15.931,36.766-84.631,36.766-84.631l17.872,80.648s-1.021,29.372,3.574,48.29a197.836,197.836,0,0,1,5.106,36.342l24-2.489s-1.532-70.692-4.085-78.159c0,0,10.723-86.125-10.723-120.475L387.747,443.79l-16.928-6.352Z",
    transform: "translate(366.892 82.59)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765-2839",
    "data-name": "Path 1765",
    d: "M334.477,299.43c32.219.55,32.214,48.475,0,49.021C302.259,347.9,302.264,299.975,334.477,299.43Z",
    transform: "translate(372.35 73.624)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766-2840",
    "data-name": "Path 1766",
    d: "M359.329,323.1h-5.476l-1.491-3.728.746,3.728H323.159l.975-7.8-7.28,7.8h-7.262v-4.227a24.869,24.869,0,1,1,49.737,0Z",
    transform: "translate(372.293 73.192)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767-2841",
    "data-name": "Path 1767",
    d: "M367.956,358.1l-60.887.493,12.869,130.521s71.2-3.758,71.244-25.49l-6.67-19.313Z",
    transform: "translate(372.092 76.286)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138-2842",
    "data-name": "Path 138",
    d: "M486.148,578.2,273.9,622.155c-2.17.444-4.674-2.788-5.6-7.228L246,507.2c-.919-4.439.1-8.4,2.265-8.856l212.245-43.953c2.17-.444,4.674,2.788,5.6,7.228l22.308,107.725C489.33,573.786,488.314,577.748,486.148,578.2Z",
    transform: "translate(367.213 83.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(671.219 589.189)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 18.954,
    cy: 18.954,
    r: 18.954,
    transform: "translate(2.395 2.652)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63-2843",
    "data-name": "Path 63",
    d: "M391.1,568.254l-91.048,18.855a1.914,1.914,0,0,1-.346.043l27.617-83.5a3.078,3.078,0,0,1,5.248-1.087l39.265,44.069,1.881,2.108Z",
    transform: "translate(-299.711 -501.508)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65-2844",
    "data-name": "Path 65",
    d: "M437.135,557.01l-78.749,16.308,10.669-25.324.767-1.824,13.9-33a4.109,4.109,0,0,1,5.9-1.594,3.667,3.667,0,0,1,.36.3Z",
    transform: "translate(-295.049 -500.761)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_138-2-2845",
    "data-name": "Path 138",
    d: "M486.148,578.2,273.9,622.155c-2.17.444-4.674-2.788-5.6-7.228L246,507.2c-.919-4.439.1-8.4,2.265-8.856l212.245-43.953c2.17-.444,4.674,2.788,5.6,7.228l22.308,107.725C489.33,573.786,488.314,577.748,486.148,578.2ZM248.93,501.562c-1.3.27-1.909,2.65-1.359,5.314L269.879,614.6c.552,2.663,2.055,4.6,3.358,4.337l212.245-43.953c1.3-.27,1.909-2.649,1.359-5.314L464.533,461.946c-.552-2.663-2.055-4.6-3.358-4.337Z",
    transform: "translate(367.213 83.934)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768-2846",
    "data-name": "Path 1768",
    d: "M411.472,480.026a10.122,10.122,0,0,1-3.965-15.006l-12.33-19.57,10.065-10.394,17.024,27.882a10.177,10.177,0,0,1-10.794,17.088Z",
    transform: "translate(379.094 82.4)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769-2847",
    "data-name": "Path 1769",
    d: "M354.808,363.295l8.833-5.821s6.816,1.528,14.067,15.473,36.487,76.287,36.487,76.287l-12.017,12.2-32.059-48.909Z",
    transform: "translate(375.886 76.236)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770-2848",
    "data-name": "Path 1770",
    d: "M305.988,494.346a10.122,10.122,0,0,0-2.92-15.244l2.646-22.979-13.572-5.014-3.28,32.5a10.177,10.177,0,0,0,17.127,10.733Z",
    transform: "translate(370.568 83.676)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771-2849",
    "data-name": "Path 1771",
    d: "M316.716,369.8l-8.011-11.2s-5.482-1.217-11.959,6.339-10.255,102.009-10.255,102.009l23.748,5.4,14.033-66.927Z",
    transform: "translate(370.457 76.32)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772-2850",
    "data-name": "Path 1772",
    d: "M567.247,702.633H155.972a1.079,1.079,0,1,1,0-2.159H567.247a1.079,1.079,0,1,1,0,2.159Z",
    transform: "translate(360 103.491)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773-2851",
    "data-name": "Path 1773",
    d: "M294.881,524.111l-35.125,7.458c.395-11.488-2.439-23.223-7.458-35.125l35.125-7.458A44.639,44.639,0,0,0,294.881,524.111Z",
    transform: "translate(367.74 86.686)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 21.763,
    height: 4.353,
    transform: "translate(626.94 589.449) rotate(-11.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 21.763,
    height: 4.353,
    transform: "translate(628.748 597.964) rotate(-11.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 21.763,
    height: 4.353,
    transform: "translate(630.556 606.479) rotate(-11.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571-2852",
    "data-name": "Path 1571",
    d: "M244.975,503.938c1.734,0,3.279-.039,4.446-.15,4.383-.4,8.568-3.642,10.673-5.534a2.988,2.988,0,0,0,.757-3.374h0a2.965,2.965,0,0,0-1.931-1.711l-11.587-3.311L228.571,477.2l-.213.378a33.43,33.43,0,0,0-2.538,5.7A2.536,2.536,0,0,0,226,485.39a2.017,2.017,0,0,0,.867.725c-.339.355-1.4,1.08-4.682,1.6-4.785.757-5.794-4.2-5.833-4.406l-.032-.166-.142-.095c-2.278-1.466-3.681-2.136-4.162-1.994-.3.087-.8.244-2.168,13.747a13.882,13.882,0,0,0-.441,6.5c.7,3.232,14.827,2.12,17.657,1.868.079.008,10.657.765,17.9.765h.008Z",
    transform: "translate(552.223 301.107)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793-2853",
    "data-name": "Path 1793",
    d: "M246.1,504.544c1.788,0,3.382-.04,4.585-.153,4.52-.411,8.837-3.722,11.007-5.655a3.035,3.035,0,0,0,.78-3.448h0a3.049,3.049,0,0,0-1.992-1.748l-11.95-3.383-15.1-13.861-.219.387c-.081.145-2.516,3.544-3.15,5.832a2.571,2.571,0,0,0,.187,2.159,2.077,2.077,0,0,0,.894.741,35.412,35.412,0,0,1-8.545,2.551c-4.935.773-5.975-4.294-6.016-4.5l-.033-.169-.146-.1c-2.349-1.5-3.8-2.183-4.292-2.038-.309.089-.829.25-2.236,14.049a14.064,14.064,0,0,0-.455,6.646c.724,3.3,15.291,2.167,18.21,1.909.081.008,10.991.781,18.462.781h.008Z",
    transform: "translate(612.89 242.661) rotate(25)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenata);
export default __webpack_public_path__ + "static/media/menata.d31400df69ba4f66755a4f9c56cc2a26.svg";
export { ForwardRef as ReactComponent };